import { ChangeEvent, useContext, useEffect, useState } from "react";
import FormacionDesarolloContext from "../../context/FormacionDesarollo/FormacionDesarrolloContext";
import { createCoursesModal } from "../../context/FormacionDesarollo/FormacionDesarrolloActions";
import { Grid } from "@material-ui/core";
import { Box } from "@mui/material";
// import AddIcon from "../../assets/svg/icono_agregar_blue.svg";
import CheckPermission from "../../helpers/Administradores/Permissions";
import CustomTabs from "../Collaborators/Tab/CustomTabs";
import CustomTab from "../Collaborators/Tab/CustomTabMain";
import Courses from "./Courses";
import TrainingPlans from "./TrainingPlans";
import Training from "./Training";
import "../FormacionDesarrollo/css/FormacionDesarrollo.css";

const FormacionDesarrolloContent = () => {
  const { state, dispatch } = useContext(FormacionDesarolloContext);
  const [tab, setTab] = useState(0);
  const handleChange = (event: ChangeEvent<{}>, newValue: number) => {
    setTab(newValue);
    localStorage.setItem("currentPillFD", String(newValue));
  };
  useEffect(() => {
    let currentPillFD = localStorage.getItem("currentPillFD");
    // console.log(
    //   "valor del tab al regresar en formacion y desarrollo",
    //   currentPillFD
    // );
    if (currentPillFD === "0") {
      setTab(0);
    }
    if (currentPillFD === "1") {
      setTab(1);
    }
    if (currentPillFD === "2") {
      setTab(2);
    }
  });
  return (
    <>
      <div className="containerAdelantos">
        <Box mt={3} ml={5} className="Title" mb={2}>
          Formación y desarrollo
        </Box>

        <Box p={5} pb={3} pt={0}>
          <Grid container justify="flex-start" alignItems="center" spacing={2}>
            <div className="containerBtnsPrincipal">
              <CustomTabs
                value={tab}
                onChange={handleChange}
                aria-label="simple tabs example"
              >
                {CheckPermission("FormacionDesarrollo.Cursos") && (
                  <CustomTab label="Cursos" value={0} />
                )}
                {CheckPermission("FormacionDesarrollo.TrainingPlans") && (
                  <CustomTab label="Planes de capacitación" value={1} />
                )}
                {CheckPermission("FormacionDesarrollo.Training") && (
                  <CustomTab label="Capacitaciones" value={2} />
                )}
              </CustomTabs>
            </div>
          </Grid>
        </Box>
        <div className="contenedor2">
          {tab === 0 && CheckPermission("FormacionDesarrollo.Cursos") && (
            <Courses />
          )}
          {tab === 1 &&
            CheckPermission("FormacionDesarrollo.TrainingPlans") && (
              <TrainingPlans />
            )}
          {tab === 2 && CheckPermission("FormacionDesarrollo.Training") && (
            <Training />
          )}
        </div>
      </div>
    </>
  );
};
export default FormacionDesarrolloContent;
